module.exports = __webpack_public_path__ + "static/manufacturing_provisional-08be3966349e0001d6978a0d566d2741.png";